const rankingItems = [
  { rank: 1, title: '她的私密生活', type: '韩漫 · 恋爱职场', heat: '🔥 本周最热', desc: '连续12周霸榜第一', iconBg: 'bg-primary-500' },
  { rank: 2, title: '咒术回战', type: '日漫 · 热血战斗', heat: '📈 上升3位', desc: '最终章连载中', iconBg: 'bg-accent-500' },
  { rank: 3, title: '一人之下', type: '国漫 · 奇幻武侠', heat: '⭐ 新入榜', desc: '第六季定档', iconBg: 'bg-secondary-500' },
  { rank: 4, title: '社内恋爱', type: '韩漫 · 搞笑日常', heat: '📈 上升5位', desc: '人气急速攀升', iconBg: 'bg-primary-400' },
  { rank: 5, title: '剑与魔法', type: '国漫 · 奇幻史诗', heat: '🆕 本周新作', desc: '原创世界观广受好评', iconBg: 'bg-accent-400' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            排行榜
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            热门漫画人气排行
          </h2>
        </div>
        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-10 h-10 rounded-lg ${item.iconBg} flex items-center justify-center flex-shrink-0`}>
                <span className="text-background-50 font-bold text-base">{item.rank}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                  <span className="text-xs text-foreground-400">{item.type}</span>
                </div>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
              <span className="text-xs font-medium text-foreground-600 whitespace-nowrap flex-shrink-0">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}